import get from 'lodash-es/get'
import * as Yup from 'yup'

import { EMPTY_STRING } from '../../../../constants/common'
import i18n from '../../../../i18n'

import {
  LOGIN_FORM_EMAIL_FIELD_NAME_PASSWORD,
  LOGIN_FORM_EMAIL_FIELD_NAME_USERNAME,
  LOGIN_FORM_EMAIL_SERVER_NON_FIELD_ERRORS,
} from './LoginFormEmail.constants'

export function parseLoginFormEmailServerError(error) {
  const errorText = get(
    error,
    ['response', 'data', 'errors', 'non_field_errors'],
    EMPTY_STRING
  )

  if (LOGIN_FORM_EMAIL_SERVER_NON_FIELD_ERRORS[errorText]) {
    return i18n.t(LOGIN_FORM_EMAIL_SERVER_NON_FIELD_ERRORS[errorText])
  }

  return errorText
}

export function getLoginFormValidationSchema() {
  return Yup.object({
    [LOGIN_FORM_EMAIL_FIELD_NAME_PASSWORD]: Yup.string().required(() => {
      return true
    }),
    [LOGIN_FORM_EMAIL_FIELD_NAME_USERNAME]: Yup.string().required(() => {
      return true
    }),
  })
}
